"use strict";
/**
 * Skin Report Narrative Enums
 *
 * Enums specific to the Stage 5 narrative layer.
 * These are used for narrative generation and display.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.growthOpportunityPriorityEnum = exports.GrowthOpportunityPriority = exports.evidenceLevelEnum = exports.EvidenceLevel = exports.productEvaluationStatusEnum = exports.ProductEvaluationStatus = exports.trajectoryBadgeEnum = exports.TrajectoryBadge = exports.scanAdherenceStatusEnum = exports.ScanAdherenceStatus = exports.imageQualityTierEnum = exports.ImageQualityTier = exports.profileConfidenceEnum = exports.ProfileConfidence = exports.actionTypeEnum = exports.ActionType = exports.evaluationStatusEnum = exports.EvaluationStatus = exports.narrativePredictionOutcomeEnum = exports.NarrativePredictionOutcome = exports.blurredTeaserTypeEnum = exports.BlurredTeaserType = exports.ahaMomentTypeEnum = exports.AhaMomentType = exports.narrativeTrajectoryEnum = exports.NarrativeTrajectory = void 0;
// ============================================================================
// NARRATIVE TRAJECTORY
// ============================================================================
/**
 * Overall narrative trajectory for Stage 5 framing
 * Determines headline tone and narrative framing
 */
exports.NarrativeTrajectory = {
    IMPROVING: 'improving',
    STABLE: 'stable',
    MIXED: 'mixed',
    NEEDS_ATTENTION: 'needs_attention',
};
exports.narrativeTrajectoryEnum = Object.values(exports.NarrativeTrajectory);
// ============================================================================
// AHA MOMENT TYPES
// ============================================================================
/**
 * Aha moment types
 * Each type serves a different psychological purpose
 */
exports.AhaMomentType = {
    PROGRESS: 'progress',
    ATTRIBUTION: 'attribution',
    PATTERN: 'pattern',
    MILESTONE: 'milestone',
    PREDICTION_ACCURACY: 'prediction_accuracy',
    FOLLOW_UP: 'follow_up',
};
exports.ahaMomentTypeEnum = Object.values(exports.AhaMomentType);
// ============================================================================
// BLURRED TEASER TYPES
// ============================================================================
/**
 * Blurred teaser types for preview section
 * Creates curiosity gap without revealing full content
 */
exports.BlurredTeaserType = {
    INSIGHT: 'insight',
    CHART: 'chart',
    ROUTINE: 'routine',
};
exports.blurredTeaserTypeEnum = Object.values(exports.BlurredTeaserType);
// ============================================================================
// PREDICTION OUTCOME (Narrative-specific)
// ============================================================================
/**
 * Prediction outcome types for narrative display
 * NOTE: Different from the database predictionOutcomeEnum which tracks actual metric changes
 * This enum is for narrative framing of resolved predictions
 */
exports.NarrativePredictionOutcome = {
    CONFIRMED: 'confirmed',
    NOT_CONFIRMED: 'not_confirmed',
    STILL_MONITORING: 'still_monitoring',
};
exports.narrativePredictionOutcomeEnum = Object.values(exports.NarrativePredictionOutcome);
// ============================================================================
// EVALUATION STATUS
// ============================================================================
/**
 * Product evaluation status
 * Based on pharmacokinetic timelines
 */
exports.EvaluationStatus = {
    TOO_EARLY: 'too_early',
    EVALUATING: 'evaluating',
    ESTABLISHED: 'established',
};
exports.evaluationStatusEnum = Object.values(exports.EvaluationStatus);
// ============================================================================
// ACTION TYPES
// ============================================================================
/**
 * Action types for priority action
 */
exports.ActionType = {
    PRODUCT: 'product',
    BEHAVIOR: 'behavior',
    ROUTINE: 'routine',
};
exports.actionTypeEnum = Object.values(exports.ActionType);
// ============================================================================
// PROFILE CONFIDENCE
// ============================================================================
/**
 * Profile type confidence levels
 */
exports.ProfileConfidence = {
    EMERGING: 'emerging',
    ESTABLISHED: 'established',
};
exports.profileConfidenceEnum = Object.values(exports.ProfileConfidence);
// ============================================================================
// IMAGE QUALITY TIER
// ============================================================================
/**
 * Image quality tier
 * Based on average quality score
 */
exports.ImageQualityTier = {
    EXCELLENT: 'excellent',
    GOOD: 'good',
    FAIR: 'fair',
    NEEDS_IMPROVEMENT: 'needs_improvement',
};
exports.imageQualityTierEnum = Object.values(exports.ImageQualityTier);
// ============================================================================
// SCAN ADHERENCE STATUS
// ============================================================================
/**
 * Scan adherence status (subsequent reports only)
 */
exports.ScanAdherenceStatus = {
    EXCEEDED: 'exceeded',
    MET: 'met',
    ALMOST: 'almost',
    MISSED: 'missed',
};
exports.scanAdherenceStatusEnum = Object.values(exports.ScanAdherenceStatus);
// ============================================================================
// TRAJECTORY BADGE
// ============================================================================
/**
 * Trajectory badge visual indicators
 */
exports.TrajectoryBadge = {
    UP: '\u2191', // ↑
    DOWN: '\u2193', // ↓
    STABLE: '\u2192', // →
    MIXED: '\u2195', // ↕
};
exports.trajectoryBadgeEnum = Object.values(exports.TrajectoryBadge);
// ============================================================================
// PRODUCT EVALUATION STATUS
// ============================================================================
/**
 * Product evaluation status for current routine products
 */
exports.ProductEvaluationStatus = {
    WORKING: 'working',
    TOO_EARLY: 'too_early',
    NOT_EFFECTIVE: 'not_effective',
    UNKNOWN: 'unknown',
};
exports.productEvaluationStatusEnum = Object.values(exports.ProductEvaluationStatus);
// ============================================================================
// EVIDENCE LEVEL (for lifestyle tips)
// ============================================================================
/**
 * Evidence level for lifestyle recommendations
 */
exports.EvidenceLevel = {
    VERY_STRONG: 'very_strong',
    STRONG: 'strong',
    MODERATE: 'moderate',
    EMERGING: 'emerging',
    ANECDOTAL: 'anecdotal',
};
exports.evidenceLevelEnum = Object.values(exports.EvidenceLevel);
// ============================================================================
// GROWTH OPPORTUNITY PRIORITY
// ============================================================================
/**
 * Priority level for growth opportunities in skin identity
 * - focus: Requires active attention (SEVERE severity)
 * - monitor: Worth watching but not urgent (MILD/MODERATE severity)
 */
exports.GrowthOpportunityPriority = {
    FOCUS: 'focus',
    MONITOR: 'monitor',
};
exports.growthOpportunityPriorityEnum = Object.values(exports.GrowthOpportunityPriority);
//# sourceMappingURL=enums.js.map